import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { resources } from "./resources";

await i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: ["en", "pt-BR"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["navigator"],
      caches: [],
      convertDetectedLanguage: (language: string) =>
        language.toLowerCase().startsWith("pt") ? "pt-BR" : language,
    },
  });

document.documentElement.lang = i18n.resolvedLanguage || "en";
document.title = i18n.t("app.title");

export { i18n };
